import { render } from "./SectionLatestAuctions.vue?vue&type=template&id=4b5db176&scoped=true"
import script from "./SectionLatestAuctions.vue?vue&type=script&lang=js"
export * from "./SectionLatestAuctions.vue?vue&type=script&lang=js"

import "./SectionLatestAuctions.vue?vue&type=style&index=0&id=4b5db176&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b5db176"]])

export default __exports__